/** Sidenav chrome width (Snowflake Stellar). */
export const SIDENAV_WIDTH = 248;
export const SIDENAV_TOTAL_WIDTH = SIDENAV_WIDTH + 1;
